import React from 'react';
import { UsersIcon } from '../../assets/icons';

interface DoctorMetricsProps {
  totalPatients: number;
}

const DoctorMetrics: React.FC<DoctorMetricsProps> = ({ totalPatients }) => {
  return (
    <div style={{ marginBottom: 40 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1f2937', marginTop: 0, marginBottom: 20 }}>
        Mis Métricas
      </h2>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: 20,
        }}
      >
        {/* Total Patients */}
        <div
          style={{
            background: '#fff',
            borderRadius: 12,
            padding: 24,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 14, color: '#6b7280', fontWeight: 500 }}>Total Pacientes</span>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: '#f0fdfa',
                color: '#38b2ac',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <UsersIcon />
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            <span style={{ fontSize: 36, fontWeight: 700, color: '#1f2937' }}>{totalPatients}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorMetrics;
